import styled from 'styled-components';
import { Flex } from 'antd';

export const SwitchOrganisationIcon = styled(Flex)`
  width: 70px;
  height: 70px;
  border-radius: 56px;
  background-color: var(--tag-yellow);
  flex-shrink: 0;
  .icon {
    font-size: 30px;
    color: var(--clr-beige-200);
    height: 30px;
    display: inline-block;
  }
`;

export const RunningTimerRow = styled(Flex)`
  background-color: var(--clr-general-hover);
  border: 1px solid var(--clr-general-border-hover);
  border-radius: 5px;
  padding: 10px 15px;
  .timer-text {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .timer-elapsed {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const RunningIndicator = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--tag-red);
  flex-shrink: 0;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background-color: var(--clr-inline-error);
  }
`;
